import Cookies from "js-cookie";
import { Recipe } from "../pages/recipe/recipe";

const apiUrl = process.env.REACT_APP_API_URL;
const apiCode = process.env.REACT_APP_API_CODE;

export async function fetchAllRecipes(greenhouseId: string): Promise<Recipe[] | undefined> {
    try {
        // Retrieve the token from cookies
        const token = Cookies.get('auth_token');

        const response = await fetch(`${apiUrl}/api/recipe?greenhouseId=${greenhouseId}&code=${apiCode}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`
            },
        });

        if (!response.ok) {
            throw new Error(`Error: ${response.status}`);
        }

        const data: Recipe[] = await response.json();
        return data;
    } catch (error) {
        console.error("Failed to fetch greenhouse data:", error);
        return undefined;
    }
}

export async function fetchRecipe(greenhouseId: string, recipeId: string): Promise<Recipe | undefined> {
    try {
        // Retrieve the token from cookies
        const token = Cookies.get('auth_token');

        const response = await fetch(`${apiUrl}/api/recipe?greenhouseId=${greenhouseId}&recipeId=${recipeId}&code=${apiCode}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`
            },
        });

        if (!response.ok) {
            throw new Error(`Error: ${response.status}`);
        }

        const data: Recipe = await response.json();
        return data;
    } catch (error) {
        console.error("Failed to fetch greenhouse data:", error);
        return undefined;
    }
}

export async function updateRecipe(greenhouseId: string, recipe: Recipe): Promise<boolean | undefined> {
    try {
        // Retrieve the token from cookies
        const token = Cookies.get('auth_token');

        // Make the API call
        const response = await fetch(`${apiUrl}/api/recipe?greenhouseId=${greenhouseId}&code=${apiCode}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(recipe),
        });


        if (!response.ok) {
            throw new Error(`Error: ${response.status}`);
        }

        return true;
    } catch (error) {
        console.error("Failed to fetch greenhouse data:", error);
        return undefined;
    }
}

export async function createRecipe(greenhouseId: string, recipe: Recipe): Promise<boolean | undefined> {
    try {
        // Retrieve the token from cookies
        const token = Cookies.get('auth_token');

        // Make the API call
        const response = await fetch(`${apiUrl}/api/recipe?greenhouseId=${greenhouseId}&code=${apiCode}`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(recipe),
        });


        if (!response.ok) {
            throw new Error(`Error: ${response.status}`);
        }

        return true;
    } catch (error) {
        console.error("Failed to fetch greenhouse data:", error);
        return undefined;
    }
}

export async function deleteRecipe(greenhouseId: string, recipe: Recipe): Promise<boolean | undefined> {
    try {
        // Retrieve the token from cookies
        const token = Cookies.get('auth_token');

        // Make the API call
        const response = await fetch(`${apiUrl}/api/recipe?greenhouseId=${greenhouseId}&code=${apiCode}`, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(recipe),
        });


        if (!response.ok) {
            throw new Error(`Error: ${response.status}`);
        }

        return true;
    } catch (error) {
        console.error("Failed to fetch greenhouse data:", error);
        return undefined;
    }
}